var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"trk-fade"}},[(_vm.busy)?_c('div',{staticClass:"trk-api-busy",attrs:{"aria-live":"polite","aria-busy":"true","role":"status"}},[_c('div',{staticClass:"trk-api-busy__panel"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("Loading…")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }